// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".invitaio[data-v-16fe6f10]{width:80%;margin:1.041667rem auto}[data-v-16fe6f10] .el-steps{min-width:62.5rem}.conetent[data-v-16fe6f10]{background-color:#fff;width:62.5rem;margin:1.041667rem auto;padding:1.041667rem}", ""]);
// Exports
module.exports = exports;
